module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Peter Lance\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Peter Lance is the author of three previous works of investigative journalism, "), _c('I', [_vm._v("1000 Years for Revenge")]), _vm._v(", "), _c('I', [_vm._v("Cover Up")]), _vm._v(", and "), _c('I', [_vm._v("Triple Cross")]), _vm._v(". A former correspondent for ABC News, he covered hundreds of stories worldwide for "), _c('I', [_vm._v("20/20")]), _vm._v(", "), _c('I', [_vm._v("Nightline")]), _vm._v(", and "), _c('I', [_vm._v("World News Tonight")]), _vm._v(". Among his awards are the Robert F. Kennedy Journalism Prize and the Sevellon Brown Award from the Associated Press. He lives in California.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15nd8Pq/tc-custom/9780061738128.jpg?1722366715745",
      "alt": "This image is the cover for the book 1000 Years for Revenge"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("1000 Years for Revenge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("1000 Years for Revenge")]), _vm._v(" is a groundbreaking investigative work that uncovers startling evidence of how the FBI missed dozens of opportunities to stop the attacks of September 11, dating back to 1989. Award-winning journalist Peter Lance explains how an elusive al Qaeda mastermind defeated the entire American security system in what the author calls \"the greatest failure of intelligence since the Trojan Horse.\" Threading the stories of FBI agent Nancy Floyd, FDNY fire marshal Ronnie Bucca, and bomb-maker Ramzi Yousef, Lance uncovers the years of behind-the-scenes intrigue that put these three strangers on a collision course. An unparalleled work of investigative reporting and masterful storytelling, "), _c('i', [_vm._v("1000 Years for Revenge")]), _vm._v(" will change forever the way we look at the FBI and the war on terror in the twenty-first century.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0